import BaseRepository from '@/api/repositories/BaseRepository';

export default class OrderDocumentationTypesRepository extends BaseRepository {
	fetchAllOrderDocumentationTypes() {
		return this.get('orderDocumentationTypes', {});
	}

	storeOrderDocumentationType(orderDocumentationType) {
		return this.post('orderDocumentationTypes', {}, orderDocumentationType);
	}

	updateOrderDocumentationType(id, orderDocumentationType) {
		return this.put(`orderDocumentationTypes/${id}`, {}, orderDocumentationType);
	}

	deleteOrderDocumentationType(id) {
		return this.delete(`orderDocumentationTypes/${id}`, {});
	}
}
